module.exports = __webpack_public_path__ + "img/system1.50bc1fa3.svg";